import { createSlice } from '@reduxjs/toolkit';

const initialState: initialStateType = {
  showNotificationPermissionBanner: !('Notification' in window) || !(Notification.permission === 'granted'),
  fcmPermissionLoading: false,
};

export const firebaseConfigSlice = createSlice({
  name: 'firebaseConfig',
  initialState: initialState,
  reducers: {
    setShowNotificationPermissionBanner: (state, action) => {
      state.showNotificationPermissionBanner = action.payload;
    },
    setFcmPermissionLoading: (state, action) => {
      state.fcmPermissionLoading = action.payload;
    },
  },
});

export const { setShowNotificationPermissionBanner, setFcmPermissionLoading } = firebaseConfigSlice.actions;
export default firebaseConfigSlice.reducer;
interface initialStateType {
  showNotificationPermissionBanner: boolean;
  fcmPermissionLoading: boolean;
}
